import React, { useState } from 'react';
import { array, func, number, string, object } from 'prop-types';
import { map, get, size, filter, includes, find, toString, toNumber, isEmpty } from 'lodash';
import moment from 'moment';
import { withApollo } from 'react-apollo';
import { Tooltip } from 'antd';
import { Pagination, Column, Text, Button, Row } from '../../common';
import { ANDROID_GREEN } from '../../../utils/colors';
import './external-factors.css';
import ListSaleschannelDrawer from './ListSaleschannelDrawer';
import ModalConfirmation from './ModalConfirmation';
import SWITCH_EXTERNAL_ISSUE from '../../../queries/SWITCH_EXTERNAL_ISSUE';

const ExternalFactorsTable = ({ data, setCurrentPage, setPageSize, pageSize, currentPage, totalPages, sessionSalesChannel, tabActive, client, email, refetchIssueLogs, motives }) => {
    const [saleschannelDrawer, setSaleschannelDrawer] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showModalConfirmation, setShowModalConfirmation] = useState(false);
    const [listSaleschannelDrawer, setListSaleschannelDrawer] = useState(false);
    const [selectedIssue, setSelectedIssue] = useState({});

    const onCloseModal = () => {
        setShowModalConfirmation(false);
    };

    const paginationProperties = {
        defaultPageSize: 10,
        pageSize,
        onChangePageSize: ({ value }) => {
            const sizeValue = get(value, 'value', 100);
            if (pageSize === 50 && sizeValue === 100) {
                const fullSizePages = totalPages / 100;
                const maxFullSizePages = fullSizePages > parseInt(fullSizePages) ? parseInt(fullSizePages + 1) : parseInt(fullSizePages);
                if (currentPage > fullSizePages) setCurrentPage(maxFullSizePages);
            }
            setPageSize(sizeValue);
        },
        onChange: value => setCurrentPage(value),
        current: currentPage,
        total: totalPages,
        optionsUp: true
    };

    const handleSaleschannelDrawer = (saleschannelIds) => {
        const salesChannels = filter(sessionSalesChannel, ({ value }) => {
            return includes(saleschannelIds, value);
        });

        setListSaleschannelDrawer(salesChannels);
        setSaleschannelDrawer(!saleschannelDrawer);
    };

    const renderLinkDrawerSalesChannel = (saleschannelIds) => {
        return <Button padding='0px' style={{ justifyContent: 'flex-start' }} onClick={() => handleSaleschannelDrawer(saleschannelIds)} link>
            Ver listado
        </Button>;
    };

    const truncateText = (text, sizeToTruncate) => size(text) > sizeToTruncate ? `${text.substring(0, sizeToTruncate - 1)}...` : text;

    const onSubmit = async () => {
        setLoading(true);
        await client.mutate({
            mutation: SWITCH_EXTERNAL_ISSUE,
            variables: { input: {
                issueId: toNumber(get(selectedIssue, 'issueId')),
                issueName: get(selectedIssue, 'motive.name', ''),
                isTurningOn: false,
                storeId: get(selectedIssue, 'saleChannelId'),
                storeFlag: get(selectedIssue, 'storeFlag'),
                user: email,
                region: 'cl'
            } }
        }).then(() => {
            setShowModalConfirmation(false);
            setLoading(false);
            refetchIssueLogs();
        });
    };

    const renderTable = () => {
        return <div style={{ overflowX: 'auto' }}>
            <Row width='100%'>
                {tabActive === 'historyMotives' && <Column flex={2.5} align='flex-start' justify='center'>
                    {map((data), (_, index) => {
                        const isFirtElement = index === 0;

                        return <Column height={94} justify='center' align='center'>
                            <Row style={{ width: 2, backgroundColor: isFirtElement ? '#F4F4F5' : ANDROID_GREEN, height: '100%' }} />
                            <Row flex={0.5} align='flex-end'>
                                <div style={{ width: 22, height: 22, border: `2px solid ${ANDROID_GREEN}`, borderRadius: '50%' }} />
                            </Row>
                            <Row style={{ width: 2, backgroundColor: ANDROID_GREEN, height: '100%' }} />
                        </Column>;
                    })}
                </Column>}
                <Column flex={97.5}>
                    {map((data), issue => {
                        const turnedOffAt = get(issue, 'turnedOffAt');
                        const turnedOnAt = get(issue, 'turnedOnAt');

                        const hourOffBy = moment(turnedOffAt).format('HH:mm');
                        const dateOffBy = moment(turnedOffAt).format('YYYY-MM-DD');

                        const hourOnBy = moment(turnedOnAt).format('HH:mm');
                        const dateOnBy = moment(turnedOnAt).format('YYYY-MM-DD');
                        const motive = find(motives, { id: get(issue, 'issueId') });

                        return <div className='row-card' style={{ backgroundColor: 'white' }} key={get(issue, 'id')}>
                            <div className='cell' style={{ flex: 0.9 }}>
                                <Column>
                                    <Tooltip title={get(motive, 'name')}>
                                        <Text text={get(motive, 'name')} strong />
                                    </Tooltip>
                                    <Text text='Motivo' />
                                </Column>
                            </div>
                            <div className='cell' style={{ flex: 1.2 }}>
                                <Column>
                                    <Tooltip title={get(issue, 'turnedOnBy')}>
                                        <Text text={truncateText(get(issue, 'turnedOnBy'), 35)} strong />
                                    </Tooltip>
                                    <Text text='Quién lo activó' />
                                </Column>
                            </div>
                            {!isEmpty(get(issue, 'turnedOffBy')) && <div className='cell' style={{ flex: 1.2 }}>
                                <div className='cell' style={{ flex: 1.2 }}>
                                    <Column>
                                        <Tooltip title={get(issue, 'turnedffBy')}>
                                            <Text text={truncateText(get(issue, 'turnedOffBy'), 35)} strong />
                                        </Tooltip>
                                        <Text text='Quién lo finalizó' />
                                    </Column>
                                </div>
                            </div>}
                            <div className='cell' style={{ flex: 1 }}>
                                <Column>
                                    {size(get(issue, 'saleChannelId')) > 1
                                        ? renderLinkDrawerSalesChannel(get(issue, 'saleChannelId'))
                                        : <Text text={get(find(sessionSalesChannel, { value: toString(get(issue, 'saleChannelId')) }), 'label')} strong />
                                    }
                                    <Text text='Tienda(s)' />
                                </Column>
                            </div>
                            <div className='cell small-cell'>
                                <Column>
                                    <Text text={dateOnBy} strong />
                                    <Text text='Fecha' />
                                </Column>
                            </div>
                            <div className='cell small-cell'>
                                <Column>
                                    <Text text={hourOnBy} strong />
                                    <Text text='Hora' />
                                </Column>
                            </div>
                            {tabActive === 'activeMotives' && get(issue, 'isTurningOn')
                                ? <div className='cell small-cell'>
                                    <Button text='Finalizar incidencia' onClick={() => {
                                        setShowModalConfirmation(true);
                                        setSelectedIssue({ ...issue, motive });
                                    }} width={150} />
                                </div>
                                : <>
                                    <div className='cell small-cell'>
                                        <Column>
                                            <Text text={dateOffBy} strong />
                                            <Text text='Fecha finalización' />
                                        </Column>
                                    </div>
                                    <div className='cell small-cell'>
                                        <Column>
                                            <Text text={hourOffBy} strong />
                                            <Text text='Hora finalización' />
                                        </Column>
                                    </div>
                                </>
                            }
                        </div>;
                    })}
                </Column>
            </Row>
            <ModalConfirmation
                onClose={onCloseModal}
                visible={showModalConfirmation}
                onSubmit={() => onSubmit(true)}
                loading={loading}
                title='finalizar esta incidencia'
                msg='Al aceptar, se finalizará la incidencia.'
            />
        </div>;
    };

    return (<>
        <Pagination {...paginationProperties} />
        <div style={{ overflowX: 'auto' }}>
            {renderTable()}
        </div>
        <ListSaleschannelDrawer
            handleSaleschannelDrawer={handleSaleschannelDrawer}
            saleschannelDrawer={saleschannelDrawer}
            saleschannels={listSaleschannelDrawer}
        />
    </>
    );
};

ExternalFactorsTable.propTypes = {
    data: array,
    setPageSize: func,
    setCurrentPage: func,
    pageSize: number,
    currentPage: number,
    totalPages: number,
    sessionSalesChannel: array,
    tabActive: string,
    client: object,
    email: string,
    refetchIssueLogs: func,
    motives: array
};

export default withApollo(ExternalFactorsTable);
